import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import SearchFilterTextfield from "noood/comp/form/search-filter/SearchFilterTextfield";
import SearchFilterMultipleSelectDropdown from "noood/comp/form/search-filter/SearchFilterMultipleSelectDropdown";
import { SearchFilterFormContext } from "noood/contexts/contexts";
import SearchFilterAmount from "noood/comp/form/search-filter/SearchFilterAmount";
import * as stylex from "@stylexjs/stylex";
import SearchFilterDateRange from "noood/comp/form/search-filter/SearchFilterDateRange";

/**
 * @typedef {Object} SearchFilterFormContextMethods
 * @property {function} __virtualSubmit
 * @property {function} __collect
 */

export var SearchFilterFormTypes = {
  TEXTFIELD: "TEXTFIELD",
  DROPDOWN: "DROPDOWN",
  DATE: "DATE",
  NUMBER: "NUMBER"
};
export default function SearchFilterForm(props) {
  var _fields$map;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    obj = _useState2[0],
    set_obj = _useState2[1];
  var fields = props.fields;
  var __collect = function __collect(filter_field) {
    var _filter_field$value, _props$__collect;
    console.log("the value is: ", filter_field);
    var new_obj = _objectSpread({}, obj);
    if ((filter_field === null || filter_field === void 0 || (_filter_field$value = filter_field.value) === null || _filter_field$value === void 0 ? void 0 : _filter_field$value.length) > 0) {
      new_obj[filter_field.property] = filter_field;
    } else {
      if (!((filter_field === null || filter_field === void 0 ? void 0 : filter_field.match_mode) === '!o' || (filter_field === null || filter_field === void 0 ? void 0 : filter_field.match_mode) === 'oo')) {
        delete new_obj[filter_field.property];
      } else {
        new_obj[filter_field.property] = filter_field;
      }
    }
    set_obj(new_obj);
    (_props$__collect = props.__collect) === null || _props$__collect === void 0 || _props$__collect.call(props, new_obj, []);
  };
  useEffect(function () {
    set_obj(props.obj);
  }, [props.obj]);
  var __virtualSubmit = function __virtualSubmit() {
    var _props$__virtualSubmi;
    (_props$__virtualSubmi = props.__virtualSubmit) === null || _props$__virtualSubmi === void 0 || _props$__virtualSubmi.call(props, obj);
  };
  var formContextValue = {
    obj: obj,
    __virtualSubmit: __virtualSubmit,
    __collect: __collect
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchFilterFormContext.Provider, {
    value: formContextValue
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: function onSubmit(e) {
      var _props$__submit;
      e.preventDefault();
      (_props$__submit = props.__submit) === null || _props$__submit === void 0 || _props$__submit.call(props, obj);
    }
  }, fields === null || fields === void 0 || (_fields$map = fields.map) === null || _fields$map === void 0 ? void 0 : _fields$map.call(fields, function (field, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: "field-".concat(idx)
    }, field.type === SearchFilterFormTypes.TEXTFIELD && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchFilterTextfield, {
      label: field.label,
      name: field.name,
      icon: field.icon,
      spacer: 8
    })), field.type === SearchFilterFormTypes.DROPDOWN && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchFilterMultipleSelectDropdown, {
      source: field.source,
      label: field.label,
      selectionLimit: 10,
      name: field.name,
      icon: field.icon
    })), field.type === SearchFilterFormTypes.NUMBER && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchFilterAmount, {
      name: field.name,
      icon: field.icon,
      label: field.label,
      units: field.units
    })), field.type === SearchFilterFormTypes.DATE && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchFilterDateRange, {
      label: field.label,
      name: field.name
    })));
  }), props.children)));
}
SearchFilterForm.propTypes = {
  __collect: PropTypes.func,
  __submit: PropTypes.func
  // if the form has no submit button (to trigger, auto submit when enter is hit in input fields), this
  // should be able to handle that
  ,

  __virtualSubmit: PropTypes.func,
  fields: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    type: PropTypes.string,
    label: PropTypes.string,
    icon: PropTypes.string
  }))
};

// @ts-ignore
_inject(".ev4z9k3i{font-size:13px}", 3000);